import type { FaireProductEntity } from "../../entity_types/product";

export const p_a8ahq4v9tp: FaireProductEntity = {
  token: "p_a8ahq4v9tp",
  type: "product",
  name: "8 ML Hanging Mini Lei Diffuser",
  brandName: "Ha\u2018a & Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/09015ee4437de7c8aff6b7dd6c8ac9ea0ec81a4bea62ecd028d2fe4dfa605143.png",
  priceDollars: 9,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/f18197305ff4ea0a3c2002e42892165ae0f5a65ae31ac19635c834fa823f12e2.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
